import { EncryptedText } from "@/components/ui/encrypted-text"
import { neonFillClass, neonGlowClass } from "@/components/ui/neon"
import { Waveform } from "@/components/ui/waveform"
import { cn } from "@/lib/utils"

type Props = {
  prefix: string
  accent: string
  prefixStartMs?: number
  accentStartMs?: number
  prefixCharMs?: number
  accentCharMs?: number
  className?: string
}

export function SectionTitle({
  prefix,
  accent,
  prefixStartMs = 200,
  accentStartMs = 450,
  prefixCharMs = 22,
  accentCharMs = 28,
  className,
}: Props) {
  return (
    <h2
      className={cn(
        "flex items-center gap-4 font-medium font-mono text-[clamp(1.5rem,3.2vw,2.3rem)] text-white uppercase leading-[1.1] tracking-tight sm:gap-6",
        className
      )}
    >
      <Waveform />
      <span className="inline-flex items-baseline gap-[0.35em]">
        <span className="inline-block">
          <EncryptedText
            text={prefix}
            encryptedClassName="text-white/30"
            revealedClassName="text-white"
            revealDelayMs={prefixCharMs}
            flipDelayMs={35}
            startDelayMs={prefixStartMs}
          />
        </span>
        <span className={cn("inline-block font-bold", neonGlowClass)}>
          <EncryptedText
            text={accent}
            encryptedClassName="text-[#3E7BD9]/45"
            revealedClassName={neonFillClass}
            revealDelayMs={accentCharMs}
            flipDelayMs={35}
            startDelayMs={accentStartMs}
          />
        </span>
      </span>
      <Waveform />
    </h2>
  )
}
